import React from 'react';
import { X, Music4, Bike, Activity, Check } from 'lucide-react';
import { motion } from 'framer-motion';

interface SettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const SettingsModal: React.FC<SettingsModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4">
      <motion.div 
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        className="glass p-6 w-full max-w-md space-y-4"
      >
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Settings</h2>
          <button onClick={onClose} className="p-2 glass-button">
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="space-y-4">
          <h3 className="text-lg font-semibold">Connected Services</h3>
          
          <div className="glass p-4 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <Music4 className="w-6 h-6" />
              <div>
                <p className="font-semibold">Spotify</p>
                <p className="text-sm text-white/70">Premium Account</p>
              </div>
            </div>
            <Check className="w-5 h-5 text-green-400" />
          </div>

          <div className="glass p-4 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <Bike className="w-6 h-6" />
              <div>
                <p className="font-semibold">Strava</p>
                <p className="text-sm text-white/70">Connected</p>
              </div>
            </div>
            <Check className="w-5 h-5 text-green-400" />
          </div>

          <div className="glass p-4 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <Activity className="w-6 h-6" />
              <div>
                <p className="font-semibold">Apple Health</p>
                <p className="text-sm text-white/70">Syncing data</p>
              </div>
            </div>
            <Check className="w-5 h-5 text-green-400" />
          </div>
        </div>

        <div className="pt-4">
          <button className="w-full glass-button p-4 text-red-300">
            Sign Out
          </button>
        </div>
      </motion.div>
    </div>
  );
};